'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.PercentFormatter', ['AVRO.Common.Formatting']).directive('rmPercentFormatter', require('./directives/PercentFormatterDirective')).controller('PercentFormatterController', require('./controllers/PercentFormatterController'));